module.exports = __webpack_public_path__ + "static/media/icon-football-white.b82dbe93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-football-white.svg
// module id = ./src/assets/images/icon-football-white.svg
// module chunks = 6